<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AQoolL/tc-custom/9781504090940.jpg?1731883415152" alt="This image is the cover for the book Agent 355"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Agent 355
      </h1>
      <p class="bookDescription body article font2">
        <b>A fictional portrayal of a real-life Revolutionary spy and her daring deeds, from the<i> New York Times</i>–bestselling author of <i>The Only Woman in the Room</i>.</b><br/><br/><i>Agent 355</i> is a result of author Marie Benedict’s quest to bring history’s most fascinating and courageous women to life for contemporary readers. Known to history only by her alias, this mysterious female spy, able to move freely and unobtrusively in Loyalist circles, became a member of George Washington’s New York–based Culper Ring. This thrilling novella depicts who Marie Benedict thinks Agent 355 could have been, though her true identity remains unknown.<br/><br/> During the sweltering summer of 1779, eighteen-year-old Elizabeth Morris attends the social events of the British-occupied city, but the forced merriment holds no charm for her. She finds herself in the company of enemy soldiers, who think nothing of discussing matters of government and war in front of mere women. This invisibility becomes Elizabeth’s greatest asset as she offers her services to Robert Townsend, a Continental sympathizer. Her bravery will bring down one of the most notorious traitors in American history and ultimately seal her fate as a woman willing to sacrifice everything for love and country.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marie Benedict
      </h2>
      
      <p class="authorDescription body article"><B>Marie Benedict </B>is a <I>New York Times&ndash;</I> and <I>USA Today</I>&ndash;bestselling author of historical fiction, including <I>The Mystery of Mrs. Christie</I>, <I>The Only Woman in the Room</I>, <I>Carnegie&rsquo;s Maid</I>, and <I>The Other Einstein</I>. With Victoria Christopher Murray, Benedict co-wrote the Good Morning America Book Club Pick and <I>New York Times</I> bestseller, <I>The Personal Librarian</I>, and <I>The First Ladies</I>, also a <I>New York Times</I> bestseller. Writing as Heather Terrell, she has also published the novels <I>The Chrysalis</I>, <I>The Map Thief</I>, and <I>Brigid of Kildare</I>. Benedict lives in Pittsburgh, Pennsylvania, with her family.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0a53aba2